import React from 'react'
import styles from './SpellCheckPanel.module.scss'

/**
 * SpellCheckPanel - Shows text fields in editable textareas with browser spell check.
 * Changes sync back to canvas fields in real-time.
 */
export default function SpellCheckPanel({ fields, onFieldUpdate, onClose }) {
  // Filter to only text fields (not images)
  const textFields = Object.entries(fields).filter(([, field]) => {
    const label = (field.label || '').toLowerCase()
    return !label.includes('image') && !label.includes('picture') && !label.includes('pose') && !label.includes('qr')
  })

  const handleTextChange = (fieldId, value) => {
    onFieldUpdate(fieldId, value)
  }

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.panel} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h3 className={styles.title}>Check Spelling</h3>
          <button type="button" className={styles.closeBtn} onClick={onClose}>
            &times;
          </button>
        </div>
        <p className={styles.description}>
          Review your text below. Misspelled words will be underlined in red by your browser.
        </p>
        <div className={styles.fieldList}>
          {textFields.map(([id, field]) => {
            const displayText = field.text || field.sampleText || ''
            return (
              <div key={id} className={styles.fieldItem}>
                <label className={styles.fieldLabel}>{field.label || 'Text'}</label>
                <textarea
                  className={styles.fieldTextarea}
                  value={displayText}
                  onChange={(e) => handleTextChange(id, e.target.value)}
                  spellCheck="true"
                  lang="en"
                  rows={Math.max(1, Math.ceil(displayText.length / 40))}
                />
              </div>
            )
          })}
          {textFields.length === 0 && (
            <p className={styles.emptyMessage}>No text fields to check.</p>
          )}
        </div>
        <div className={styles.footer}>
          <button type="button" className={styles.doneBtn} onClick={onClose}>
            Done
          </button>
        </div>
      </div>
    </div>
  )
}
